export const POSES = ["/brand/genie.png", "/brand/genie-point.png", "/brand/genie-celebrate.png"];

export const WAYPOINTS = [
    { id: "#hero", pose: 0, xFrac: 0.8, yRatio: 0.47, scale: 1, rot: -2, mobile: { xFrac: 0.78, yRatio: 0.42, scale: 0.88 }, initial: true },
    { id: "#services", pose: 1, xFrac: 0.9, yRatio: 0.4, scale: 0.8, rot: -2 },
    { id: "#how-it-works", pose: 1, xFrac: 0.1, yRatio: 0.52, scale: 0.78, rot: 2 },
    { id: "#why-reno-genie", pose: 0, xFrac: 0.9, yRatio: 0.34, scale: 0.78, rot: -2, mobile: { xFrac: 0.88, yRatio: 0.3, scale: 0.66 } },
    { id: "#showcase", pose: 2, xFrac: 0.1, yRatio: 0.5, scale: 0.72, rot: 2, mobile: { xFrac: 0.88, yRatio: 0.32, scale: 0.64 } },
    { id: "#cta", pose: 2, xFrac: 0.82, yRatio: 0.5, scale: 0.95, rot: 0, mobile: { xFrac: 0.8, yRatio: 0.78, scale: 0.82 }, stay: true },
];

export const PATH_STOPS = WAYPOINTS.map(({ id, xFrac }) => ({ id, xFrac }));

export const waypointFor = (sectionId) => WAYPOINTS.find((wp) => wp.id === sectionId);

export const targetFor = (el, wp) => {
    const mob = window.innerWidth < 768;
    const conf = mob && wp.mobile ? { ...wp, ...wp.mobile } : wp;
    let w = el.offsetWidth;
    let h = el.offsetHeight;
    if (!h) {
        const baseImg = el.querySelector("img");
        if (baseImg?.naturalWidth && baseImg.naturalHeight) {
            h = w ? (w / baseImg.naturalWidth) * baseImg.naturalHeight : baseImg.naturalHeight;
            if (!w) w = baseImg.naturalWidth;
        }
    }
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const half = (w * conf.scale) / 2;
    const cx = Math.min(Math.max(conf.xFrac * vw, half + 12), vw - half - 12);
    return { x: cx - w / 2, y: vh * conf.yRatio - h / 2, scale: conf.scale, rotation: conf.rot };
};

/** Viewport anchor (genie center) for a waypoint — used by magic-path segment positioning. */
export const anchorFor = (wp) => {
    const mob = window.innerWidth < 768;
    const conf = mob && wp.mobile ? { ...wp, ...wp.mobile } : wp;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const half = (320 * conf.scale) / 2;
    const cx = Math.min(Math.max(conf.xFrac * vw, half + 12), vw - half - 12);
    return { x: cx, y: vh * conf.yRatio };
};

/** Path draw metrics scaled by viewport — desktop full, tablet shorter, mobile minimal. */
export const pathMetricsForViewport = () => {
    const w = window.innerWidth;
    if (w >= 1024) {
        return { offsetX: 72, offsetY: 48, ctrlX: 18, ctrlY: 36, strokeWidth: 3, glowWidth: 8, opacity: 0.55 };
    }
    if (w >= 768) {
        return { offsetX: 54, offsetY: 34, ctrlX: 14, ctrlY: 26, strokeWidth: 2.5, glowWidth: 6, opacity: 0.48 };
    }
    return { offsetX: 38, offsetY: 22, ctrlX: 10, ctrlY: 16, strokeWidth: 2, glowWidth: 5, opacity: 0.4 };
};

/** Short local curve toward the genie anchor — reuses MagicPath gold stroke language. */
export const buildLocalSegmentPath = (wp) => {
    const mob = window.innerWidth < 768;
    const conf = mob && wp.mobile ? { ...wp, ...wp.mobile } : wp;
    const dest = anchorFor(wp);
    const fromRight = conf.xFrac >= 0.5;
    const m = pathMetricsForViewport();
    const startX = dest.x + (fromRight ? m.offsetX : -m.offsetX);
    const startY = dest.y + m.offsetY;
    const ctrlX = dest.x + (fromRight ? m.ctrlX : -m.ctrlX);
    const ctrlY = dest.y - m.ctrlY;
    return {
        d: `M ${startX} ${startY} Q ${ctrlX} ${ctrlY} ${dest.x} ${dest.y}`,
        dest,
        metrics: m,
    };
};
